import { Box } from "@mui/material";
import { ToggleableAnglesVideoPlayer } from "components/scrapEyeDataDashboard/VideoPlayer/components/ToggleableAnglesVideoPlayer";
import { DIALOG_KEYBOARD_SEEK_STEP_SECONDS } from "components/scrapEyeDataDashboard/VideoPlayer/constants";
import { Dayjs } from "dayjs";
import { EDIT_EVENT_SCOPE } from "../hotkeyScopes";

interface EditEventVideoSectionProps {
  location: string;
  videoStart: Dayjs;
  videoEnd: Dayjs;
  videoDuration: number;
  badgeLocationName?: string;
}

export const EditEventVideoSection = ({
  location,
  videoStart,
  videoEnd,
  videoDuration,
  badgeLocationName,
}: EditEventVideoSectionProps) => {
  return (
    <Box sx={{ maxHeight: "50%", p: 2 }}>
      <ToggleableAnglesVideoPlayer
        storageKey="edit-event-video-player"
        location={location}
        startIso={videoStart.toISOString()}
        endIso={videoEnd.toISOString()}
        showVideoControls={false}
        badgeLocationName={badgeLocationName}
        hotkeyScope={EDIT_EVENT_SCOPE}
        keyboardSeek={{
          stepSeconds: DIALOG_KEYBOARD_SEEK_STEP_SECONDS,
          ceilingSeconds: videoDuration,
        }}
      />
    </Box>
  );
};
